import { Injectable } from '@angular/core';

import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment-timezone';

import { DateService } from '@tablesready/common-ui';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  constructor(
    private readonly dateService: DateService
  ) {
  }

  convertHours(hours, timezone) {
    Object.keys(hours).forEach(key => {
      if (hours[key].closed || !(hours[key].hours?.length > 0)) {
        return false;
      }
      const nextDay = hours[key].nextDay ?? false;
      hours[key].hours[0] = this.convertHourToTimestamp(hours[key].hours[0], nextDay, timezone);
      const maxHoursArrayLength = 2;
      if (hours[key].hours.length === maxHoursArrayLength) {
        hours[key].hours[1] = this.convertHourToTimestamp(hours[key].hours[1], nextDay, timezone);
      }
      return false;
    });
    return hours;
  }

  convertHourToTimestamp(hours, nextDay, timezone) {
    const hoursArray = !Array.isArray(hours) && typeof hours === 'object'
      ? Object.values(hours)
      : hours;

    return hoursArray.map((value, key) => {
      if (typeof value === 'string') {
        return value;
      }

      const day = nextDay && key === 1 ? 2 : 1;
      return this.dateService.convertHoursToTimestamp(value, timezone, day);
    });
  }

  checkCloseDays(days) {
    if (Object.keys(days).includes('closed' || 'hours')) {
      // object passed in is an exception date, not a schedule
      if (days.closed) {
        // remove hours if closed
        days.hours = [['', '']];
      } else {
        // remove any empty from/to arrays that have empty elements
        days.hours = this.setHoursArray(days);
      }
    } else {
      for (const key of Object.keys(days)) {
        if (days[key].closed || days.closed) {
          // remove hours if closed
          days[key].hours = [['', '']];
        } else {
          // remove any empty from/to arrays that have empty elements
          days[key].hours = this.setHoursArray(days[key]);
        }
      }
    }
  }

  setHoursArray(days) {
    return !Array.isArray(days.hours) || !days.hours.filter((a) => a.filter(Boolean).length === 2).length ? [ // eslint-disable-line no-magic-numbers
      ['', ''],
    ] : days.hours.filter((a) => a.filter(Boolean).length === 2); // eslint-disable-line no-magic-numbers
  };

  convertSchedule(schedule, timezone) {
    const _schedule = cloneDeep(schedule);

    if (!(_schedule.exceptions?.length > 0)) {
      _schedule.exceptions = [];
    }

    this.convertTimestamp(_schedule.hours ?? [], timezone);
    this.convertTimestamp(_schedule.exceptions, timezone);
    this.convertDatestamp(_schedule.exceptions, timezone);

    return _schedule;
  }

  convertTimestamp(hours, timezone) {
    Object.keys(hours).map(key => {
      if (hours[key].closed || !hours[key].hours.length) {
        return '';
      }

      hours[key].hours[0] = this.convertTimestampToHour(hours[key].hours[0], timezone);
      const maxHoursArrayLength = 2;
      if (hours[key].hours.length === maxHoursArrayLength) {
        hours[key].hours[1] = this.convertTimestampToHour(hours[key].hours[1], timezone);
      }
      return '';
    });
    return hours;
  }

  convertTimestampToHour(time, timezone) {
    return time.map((i) => {
      if (i === '') {
        return i;
      }
      const date = moment(Number(i)).tz(timezone),
        dateFormat = date.format('H:mm').split(':');

      return {hours: Number(dateFormat[0]), minutes: Number(dateFormat[1])};
    });
  }

  convertDatestamp(dates, timezone) {
    Object.keys(dates).map((key) => {
      if (!dates[key].hours.length) {
        return '';
      }
      dates[key].date = moment(Number(dates[key].date)).tz(timezone).format('MMM D, YYYY');
      return '';
    });
    return dates;
  }

  convertDates(dates, timezone) {
    Object.keys(dates).map(key => {
      if (!dates[key].date.length || !isNaN(Number(dates[key].date))) {
        return false;
      }
      dates[key].date = moment.tz(dates[key].date, 'MMM D, YYYY', timezone).format('x');
      return false;
    });
    return dates;
  }
}
